import React from 'react';
import '../styles/ErrorModal.css';

const Modal=({message,onClose})=>{
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default Modal;